import React from "react";
import { Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Select from "antd/lib/select";
import { Field, Form, Formik } from "formik";
import { FilterFormValues, FilterProps } from "../../types";
import { Button, Col, Label } from "../../styles";
import DateInput from "../dateInput";
import { can, PortalPermissions } from "../../../../config/permissions";

const initialValues: FilterFormValues = {
  question: "",
  isActive: "",
  validFrom: "",
  validTo: "",
};

const statusOptions = [
  { label: "Status", value: "" },
  { label: "Ativa", value: "true" },
  { label: "Inativa", value: "false" },
];

const Filter: React.FC<FilterProps> = ({ onFilter, onCreate }) => {
  const handleSubmit = (values: FilterFormValues) => {
    onFilter({
      question: values.question || undefined,
      isActive: values.isActive ? values.isActive === "true" : undefined,
      validFrom: values.validFrom || undefined,
      validTo: values.validTo ? `${values.validTo}T23:59:59` : undefined,
    });
  };

  return (
    <div>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Row gutter={16} align="middle">
              <Col>
                <Field type="text" name="question" placeholder="Pergunta" />
              </Col>

              <Col>
                <Select
                  value={values.isActive}
                  style={{ width: "100%" }}
                  options={statusOptions}
                  onChange={(value) => setFieldValue("isActive", value)}
                />
              </Col>

              <Col>
                <DateInput
                  placeholder="Data inicial"
                  value={values.validFrom}
                  onChange={(e) => setFieldValue("validFrom", e.target.value)}
                />
              </Col>

              <Col>
                <DateInput
                  placeholder="Data final"
                  value={values.validTo}
                  onChange={(e) => setFieldValue("validTo", e.target.value)}
                />
              </Col>

              <Col>
                <Button htmlType="submit">Consultar</Button>
              </Col>

              <Col style={{ marginLeft: "auto" }}>
                {can(PortalPermissions.administracao.pesquisaNps.criar) && (
                  <Button icon={<PlusOutlined />} onClick={onCreate}>
                    Nova Pesquisa
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Filter;
